import type { FunctionComponent, ComponentClass } from "react";

export { getDisplayName };

const getDisplayName = <T>(
  Component: FunctionComponent<T> | ComponentClass<T>,
  defaultName: string,
): string => {
  return Component.displayName || Component.name || defaultName;
};
